(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-main-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-main"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hidden-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      console.log('hide run')
    super.hide();
    }

    show(opener) {
      console.log('show run')

    super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      console.log(this)

      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      console.log(activeMedia)

      const activeMediaTemplate = activeMedia.querySelector('template');
      console.log(activeMediaTemplate)

      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      console.log(activeMediaContent)

      activeMedia.classList.add('active');

      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      console.log(container)

      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hidden-tabs"]) return;
  try {
    
// Listen for clicks on any element with the class "mobile_tab_toggle"
document.querySelectorAll('.mobile_tab_toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
        // Find the parent .tab element of the clicked toggle
        var parentTab = this.closest('.tab');
       
        // Check if the parent .tab has the class "mobile_tab_active"
        if (parentTab.classList.contains('mobile_tab_active')) {
            // If it does, remove the class
            parentTab.classList.remove('mobile_tab_active');
        } else {
            // If it doesn't, add the class
            parentTab.classList.add('mobile_tab_active');
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
  console.log('inner width:', window.innerWidth)
    if(window.innerWidth > 767) {
      console.log('Activating buttons')
        // Initialize the first tab and tab content as active
        document.querySelector('.tab_buttons li:first-child a').classList.add('active');
        var firstTabContent = document.querySelector('#tabs_contents .tabs_wrapper > div:first-child');
        firstTabContent.style.display = 'block';
        firstTabContent.classList.add('active_tab');
        firstTabContent.style.opacity = 1;
     
        var tabButtons = document.querySelectorAll('.tab_buttons li a');
     
        tabButtons.forEach(function(tabButton) {
            tabButton.addEventListener('click', function(e) {
                e.preventDefault(); // Prevent the default anchor behavior


                var currentAttrValue = this.getAttribute('href');
         
                // Remove 'active' class from any tab button
                document.querySelectorAll('.tab_buttons li a').forEach(function(btn) {
                    btn.classList.remove('active');
                });
                // Add 'active' class to the clicked tab button
                this.classList.add('active');
         
                // Animate out the active content
                var activeContent = document.querySelector('#tabs_contents .tabs_wrapper > div.active_tab');
                activeContent.style.opacity = 0;
                setTimeout(function() { // setTimeout used to replicate jQuery's animate with 0 duration
                    activeContent.classList.remove('active_tab');
                    activeContent.style.display = 'none';
         
                    // Show and animate the new active content
                    var newActiveContent = document.querySelector(currentAttrValue);
                    newActiveContent.style.display = 'block';
                    setTimeout(function() { // setTimeout used to allow the display change to take effect
                        newActiveContent.style.opacity = 1;
                    }, 0); // timeout set to 0, adjust as needed for animation
                    newActiveContent.classList.add('active_tab');
                }, 0);
            });
        });
     
        // Manually trigger a click on the first tab to set the initial state correctly
        document.querySelector('.tab_buttons li:first-child a').click();
    }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-hulkapps-backup"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
constructor() {
super();

this.addEventListener('change', debounce((event) => {
const body = JSON.stringify({ note: event.target.value });
fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
}, 300))
}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-basic"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-swatches"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-test"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      console.log('hide run')
    super.hide();
    }

    show(opener) {
      console.log('show run')

    super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      console.log(this)

      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      console.log(activeMedia)

      const activeMediaTemplate = activeMedia.querySelector('template');
      console.log(activeMediaTemplate)

      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      console.log(activeMediaContent)

      activeMedia.classList.add('active');

      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      console.log(container)

      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      console.log('hide run');
      super.hide();
    }

    show(opener) {
      console.log('show run');

      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      console.log(this);

      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      console.log(activeMedia);

      const activeMediaTemplate = activeMedia.querySelector('template');
      console.log(activeMediaTemplate);

      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      console.log(activeMediaContent);

      activeMedia.classList.add('active');

      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      console.log(container);

      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product2"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      console.log('hide run')
    super.hide();
    }

    show(opener) {
      console.log('show run')

    super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      console.log(this)

      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      console.log(activeMedia)

      const activeMediaTemplate = activeMedia.querySelector('template');
      console.log(activeMediaTemplate)

      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      console.log(activeMediaContent)

      activeMedia.classList.add('active');

      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      console.log(container)

      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poosh-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function initMegaMenu() {
    const items = document.querySelectorAll('[data-mega-menu]');
    if (!items.length) return;

    const isCoarsePointer = window.matchMedia('(hover: none)').matches;

    const closeItem = (item) => {
      item.classList.remove('is-open');
      const trigger = item.querySelector('.mega-menu__trigger');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (document.activeElement === trigger) trigger.blur();
      }
      item.querySelectorAll('.mega-menu-panel__item--has-submenu.is-expanded').forEach((submenuItem) => {
        submenuItem.classList.remove('is-expanded');
        const submenuTrigger = submenuItem.querySelector('.mega-menu-panel__link--second-level');
        if (submenuTrigger) submenuTrigger.setAttribute('aria-expanded', 'false');
      });
    };

    const clearNoAnim = (el) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => el.classList.remove('no-anim'));
      });
    };

    const openItem = (item) => {
      const swappingFromOpen = [...items].some(
        (i) => i !== item && i.classList.contains('is-open')
      );
      items.forEach((other) => {
        if (other === item) return;
        if (other.classList.contains('is-open')) {
          other.classList.add('no-anim');
          closeItem(other);
          clearNoAnim(other);
        } else {
          closeItem(other);
        }
      });
      if (swappingFromOpen) {
        item.classList.add('no-anim');
        clearNoAnim(item);
      }
      item.classList.add('is-open');
      const trigger = item.querySelector('.mega-menu__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    };

    let leaveTimer = null;
    const cancelLeaveTimer = () => {
      if (leaveTimer) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
      }
    };
    const scheduleCloseAll = () => {
      cancelLeaveTimer();
      leaveTimer = setTimeout(() => items.forEach(closeItem), 120);
    };

    items.forEach((item) => {
      const trigger = item.querySelector('.mega-menu__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', (e) => {
        const href = trigger.getAttribute('href');
        const hasNoTarget = !href || href === '#' || href === '';
        const isOpen = item.classList.contains('is-open');

        if (isCoarsePointer || hasNoTarget) {
          e.preventDefault();
          cancelLeaveTimer();
          isOpen ? closeItem(item) : openItem(item);
        }
      });

      // hover-intent: open immediately; close is handled at the menu-list
      // level so dead zones between <li>'s (gap) don't trigger a close.
      item.addEventListener('mouseenter', () => {
        cancelLeaveTimer();
        if (!item.classList.contains('is-open')) openItem(item);
      });

      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) closeItem(item);
      });

      item.querySelectorAll('.mega-menu-panel__item--has-submenu > .mega-menu-panel__link--second-level').forEach((submenuTrigger) => {
        submenuTrigger.addEventListener('click', (e) => {
          e.preventDefault();
          const submenuItem = submenuTrigger.closest('.mega-menu-panel__item--has-submenu');
          const isExpanded = submenuItem.classList.contains('is-expanded');

          submenuItem.parentElement.querySelectorAll('.mega-menu-panel__item--has-submenu.is-expanded').forEach((openSubmenuItem) => {
            if (openSubmenuItem === submenuItem) return;
            openSubmenuItem.classList.remove('is-expanded');
            const openSubmenuTrigger = openSubmenuItem.querySelector('.mega-menu-panel__link--second-level');
            if (openSubmenuTrigger) openSubmenuTrigger.setAttribute('aria-expanded', 'false');
          });

          submenuItem.classList.toggle('is-expanded', !isExpanded);
          submenuTrigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        });
      });
    });

    const menuList = items[0].closest('.menu-list');
    if (menuList) {
      menuList.addEventListener('mouseenter', cancelLeaveTimer);
      menuList.addEventListener('mouseleave', scheduleCloseAll);
    }

    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-mega-menu]')) {
        items.forEach(closeItem);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') items.forEach(closeItem);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"]) return;
  try {
    
  // Listen for clicks on any element with the class "mobile_tab_toggle"
  document.querySelectorAll('.mobile_tab_toggle').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
          // Find the parent .tab element of the clicked toggle
          var parentTab = this.closest('.tab');


          // Check if the parent .tab has the class "mobile_tab_active"
          if (parentTab.classList.contains('mobile_tab_active')) {
              // If it does, remove the class
              parentTab.classList.remove('mobile_tab_active');
          } else {
              // If it doesn't, add the class
              parentTab.classList.add('mobile_tab_active');
          }
      });
  });


  document.addEventListener('DOMContentLoaded', function() {
    console.log('inner width:', window.innerWidth)
      if(window.innerWidth > 767) {
        console.log('Activating buttons')
          // Initialize the first tab and tab content as active
          document.querySelector('.tab_buttons li:first-child a').classList.add('active');
          var firstTabContent = document.querySelector('#tabs_contents .tabs_wrapper > div:first-child');
          firstTabContent.style.display = 'block';
          firstTabContent.classList.add('active_tab');
          firstTabContent.style.opacity = 1;


          var tabButtons = document.querySelectorAll('.tab_buttons li a');


          tabButtons.forEach(function(tabButton) {
              tabButton.addEventListener('click', function(e) {
                  e.preventDefault(); // Prevent the default anchor behavior


                  var currentAttrValue = this.getAttribute('href');


                  // Remove 'active' class from any tab button
                  document.querySelectorAll('.tab_buttons li a').forEach(function(btn) {
                      btn.classList.remove('active');
                  });
                  // Add 'active' class to the clicked tab button
                  this.classList.add('active');


                  // Animate out the active content
                  var activeContent = document.querySelector('#tabs_contents .tabs_wrapper > div.active_tab');
                  activeContent.style.opacity = 0;
                  setTimeout(function() { // setTimeout used to replicate jQuery's animate with 0 duration
                      activeContent.classList.remove('active_tab');
                      activeContent.style.display = 'none';


                      // Show and animate the new active content
                      var newActiveContent = document.querySelector(currentAttrValue);
                      newActiveContent.style.display = 'block';
                      setTimeout(function() { // setTimeout used to allow the display change to take effect
                          newActiveContent.style.opacity = 1;
                      }, 0); // timeout set to 0, adjust as needed for animation
                      newActiveContent.classList.add('active_tab');
                  }, 0);
              });
          });


          // Manually trigger a click on the first tab to set the initial state correctly
          document.querySelector('.tab_buttons li:first-child a').click();
      }
  });

  } catch(e) { console.error(e); }
})();
})();
